<template>
    <div v-if="allowToRoute" @click.stop class="tower-details-link-wrapper">
        <!-- The router-link tag dynamically creates link (a) tag with href attr which enables option to open in new tab -->
        <!-- Here :to attr sets dynamic routePath value to href -->
        <!-- Navigate to the specified route with required parameter -->
        <v-icon v-if="iconName" :icon="iconName" size="small" color="warning" class="mr-1" :title="iconTitleStr"/>
        <router-link v-if="params.value != null" class="nm-link"
            :title="$t('detailsLinkTT') + ' -- ' + displayString"
            :to="{name: params.routeName, params: {id:`${id}`}}">
            {{displayString}}
        </router-link>
    </div>
    <div v-else class="tower-details-link-wrapper">
        <span :title="displayString">{{displayString}}</span>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import TimeUtil from "../services/timeUtil"

    export default defineComponent({
        name: 'DetailsLinkRenderer',
        data: function() {
            return {
                // By default, setting it to true
                allowToRoute: true,
                displayString: '',
                iconName: null,
                iconTitleStr: ''
            }
        },
        created()
        {
            this.router = this.params.context.router
            this.displayString = this.params.value? this.params.value : this.$t("common.notset")
            if(this.params.routeName === "towerDetails" && this.params.getTowerNameMap)
            {
                let towerName = this.params.getTowerNameMap()?.[this.params.value]
                if (towerName)
                {
                    this.displayString += " (" + towerName +")"
                }
            }
            if ((this.params.idField) && (this.params.data))
            {
                this.id = this.params.data[this.params.idField]
            }
            else
            {
                this.id = this.params.value
            }
            // if column cell value and selectedDetailRepId(the one we currently drilled down) are same then it's not required to render the route link
            if (this.params.selectedDetailRepId && this.params.selectedDetailRepId == this.id)
            {
                this.allowToRoute = false
            }
            if ((this.params.bestTowerId) && (this.params.bestTowerId.toString() === this.params.value.toString()))
            {
                this.iconName = 'cell_tower'
                this.iconTitleStr="Best base station calculated on " + TimeUtil.nmFormatDateDisplayStringWithTZ(this.params.bestTowerDate)
            }
        }
    })
</script>

<style lang="scss" scoped>
    .tower-details-link-wrapper
    {
        position: relative;
        width: 100%;

        a.nm-link:hover
        {
            text-decoration: underline;
        }

        a
        {
            width: 100%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: bottom;
        }
    }
</style>
